import { RichText } from '../atoms/RichText';
import { ImageBlock, ImageBlockProps } from '../molecules/ImageBlock';
import { IconChevron } from '../molecules/IconChevron';
import { SimpleReactComponentProps } from '../../../types/components';
import { LinkComponent } from '../molecules/LinkComponent';

export interface ContentCardProps extends SimpleReactComponentProps {
	title: string;
	url: string;
	image?: ImageBlockProps;
	summary?: string;
}

const contentCardBlockClassNames =
	'flex flex-col justify-center mt-0 bg-white rounded-lg overflow-hidden shadow-md scroll-mt-[84px] h-full';
const imageClassOverrides = 'w-full aspect-[16/9] object-cover ';
const titleClassNames = 'pr-[10px] pl-[20px] pt-[10px] text-md text-primary';
const summaryClassNames = 'pt-[10px] p-[10px] text-md text-primary text-sm';

export const ContentCard = ({
	title,
	url,
	image,
	summary,
	anchorId,
}: ContentCardProps) => {
	const titleWords = title.split(' ');
	const hasMultipleWords = titleWords.length > 1;
	const titleLastWord =
	hasMultipleWords ? titleWords.pop() : titleWords[0];
	const remainingTitle = titleWords.join(' ');

	return (
		<section className={contentCardBlockClassNames} id={anchorId?.value}>
			<LinkComponent url={url} className="h-full">
				{image?.src && (
					<ImageBlock {...image} classOverrides={imageClassOverrides} />
				)}
				{title && (
					<p className={titleClassNames}>
						{hasMultipleWords ? `${remainingTitle} `: null}
						<span className="inline-flex items-baseline h-full">
							<span className='pr-2'>{titleLastWord}</span>
							<IconChevron direction="right" />
						</span>
					</p>
				)}
				{summary && (
					<RichText richText={summary} className={summaryClassNames} />
				)}
			</LinkComponent>
		</section>
	);
};
